import Call from "../page-modules/home-page/GenerateTypes/Types/Call/Call";
import Url from "../page-modules/home-page/GenerateTypes/Types/Url/Url";
import Text from "../page-modules/home-page/GenerateTypes/Types/Text/Text";
import Email from "../page-modules/home-page/GenerateTypes/Types/Email/Email";
import Sms from "../page-modules/home-page/GenerateTypes/Types/Sms/Sms";
import TypesWithSignUp from "../page-modules/home-page/GenerateTypes/Types/TypesWithSignUp/TypesWithSignUp";
import Wifi from "../page-modules/home-page/GenerateTypes/Types/Wifi/Wifi";
import Pdf from "../page-modules/home-page/GenerateTypes/Types/Pdf/Pdf";
import Social from "../page-modules/home-page/GenerateTypes/Types/Social/Social";
import Bitcoin from "../page-modules/home-page/GenerateTypes/Types/Bitcoin/Bitcoin";
import Rating from "../page-modules/home-page/GenerateTypes/Types/Rating/Rating";
import Menu from "../page-modules/home-page/GenerateTypes/Types/Menu/Menu";
import Feedback from "../page-modules/home-page/GenerateTypes/Types/FeedBack/FeedBack";
import { forRender } from "@/constant";

const typesComponentForHomePage: {
  type: string;
  components: () => JSX.Element;
}[] = [
  {
    type: forRender.url,
    components: Url,
  },
  {
    type: forRender.call,
    components: Call,
  },
  {
    type: forRender.text,
    components: Text,
  },
  {
    type: forRender.email,
    components: Email,
  },
  {
    type: forRender.sms,
    components: Sms,
  },
  {
    type: forRender.wifi,
    components: Wifi,
  },
  {
    type: forRender.raiting,
    components: Rating,
  },
  {
    type: forRender.linkedin,
    components: Social,
  },
  {
    type: forRender.pdf,
    components: Pdf,
  },
  {
    type: forRender.menu,
    components: Menu,
  },
  {
    type: forRender.feedback,
    components: Feedback,
  },
  {
    type: forRender.bitcoin,
    components: Bitcoin,
  },
  {
    type: forRender.app,
    components: TypesWithSignUp,
  },
  {
    type: forRender.business,
    components: TypesWithSignUp,
  },
  {
    type: forRender.images,
    components: TypesWithSignUp,
  },
  {
    type: forRender.location,
    components: TypesWithSignUp,
  },
  {
    type: forRender.social,
    components: TypesWithSignUp,
  },
  {
    type: forRender.vcard,
    components: TypesWithSignUp,
  },

  {
    type: forRender.coupon,
    components: TypesWithSignUp,
  },
  {
    type: forRender.video,
    components: TypesWithSignUp,
  },
  {
    type: forRender.facebook,
    components: TypesWithSignUp,
  },
  {
    type: forRender.mp3,
    components: TypesWithSignUp,
  },
  {
    type: forRender.event,
    components: TypesWithSignUp,
  },
];

export default typesComponentForHomePage;
